// Đợt Offline-3 — Banner trạng thái mạng toàn app (chỉ context public).
// offline → amber "đang hiển thị dữ liệu đã lưu lúc HH:mm";
// reconnecting → sky "đang kết nối lại". Passive context (referee/publisher/
// admin) KHÔNG hiện — họ có connection-lock/watchdog riêng.
import { useEffect, useState } from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import * as governor from "../../lib/networkGovernor";

export const OfflineBanner = () => {
  const [net, setNet] = useState(() => governor.getNetworkState());
  const [savedAt, setSavedAt] = useState(null);
  useEffect(() => {
    const unsub = governor.subscribe(setNet);
    const onData = (e) => {
      const at = e?.detail?.savedAt;
      if (at) setSavedAt((prev) => (prev && prev > at ? prev : at));
    };
    window.addEventListener("pl:offline-data-served", onData);
    return () => {
      unsub();
      window.removeEventListener("pl:offline-data-served", onData);
    };
  }, []);
  if (net.passive || net.state === "online") return null;
  const reconnecting = net.state === "reconnecting";
  const timeStr = savedAt
    ? new Date(savedAt).toLocaleTimeString("vi-VN", { hour: "2-digit", minute: "2-digit" })
    : null;
  return (
    <div
      data-testid="offline-banner"
      className={`sticky top-0 z-[70] flex items-center justify-center gap-2 px-4 py-1.5 text-xs font-bold border-b ${
        reconnecting
          ? "bg-sky-950/95 border-sky-400/30 text-sky-300"
          : "bg-amber-950/95 border-amber-400/30 text-amber-300"
      }`}
    >
      {reconnecting ? (
        <>
          <RefreshCw className="w-3.5 h-3.5 animate-spin" />
          <span>Đang kết nối lại…</span>
        </>
      ) : (
        <>
          <WifiOff className="w-3.5 h-3.5" />
          <span data-testid="offline-banner-text">
            Mất kết nối mạng — hiển thị dữ liệu đã lưu{timeStr ? ` lúc ${timeStr}` : ""}
          </span>
        </>
      )}
    </div>
  );
};

export default OfflineBanner;
